import { AnimatePresence } from 'framer-motion'
import type { Item } from '../../lib/supabase'
import type { Need } from '../../lib/recipeBook'
import type { Choice } from '../../lib/choices'
import { SheetPanel } from '../SheetPanel'
import { ChoicesPanel } from './ChoicesPanel'
import { isLongTitle } from '../../lib/title'

// The choices as a sheet of their own: "Shopping for 2 recipes" from the
// Recipes tab, "Shopping for Wed 7 to Sun 11 Oct" from the Plan tab, with the
// recipes or meals as chips. One recipe shows the same panel inside its detail.
export function ChoicesSheet(props: {
  open: boolean
  kicker: string
  title: string
  chips: string[]
  needs: Need[]
  items: Item[]
  source: 'recipe' | 'recipes' | 'plan'
  /** Above another sheet (the recipe page opens it over itself). */
  zIndex?: number
  locale?: string
  /** Names bought before, suggested when a row is edited. */
  before?: { name: string }[]
  onApply: (needs: Need[], choices: Choice[]) => void
  onClose: () => void
}) {
  const { open, kicker, title, chips, onClose, zIndex, ...panel } = props
  return (
    <AnimatePresence>
      {open && (
        <SheetPanel onClose={onClose} maxHeight="92dvh" layout="scroll" ariaLabel={`${kicker} ${title}`} wide zIndex={zIndex}>
          <header className="ml-choices-sheet__head">
            <div>
              <p className="ml-label ml-choices-sheet__kicker">{kicker}</p>
              <h2 className={`ml-display ml-choices-sheet__title${isLongTitle(title) ? ' is-long' : ''}`}>{title}</h2>
            </div>
            <button type="button" className="ml-btn ml-btn--secondary" onClick={onClose}>Close</button>
          </header>
          <ul className="ml-chips ml-choices-sheet__chips">
            {chips.map(c => <li key={c} className="ml-chip-tag">{c}</li>)}
          </ul>
          <ChoicesPanel {...panel} />
        </SheetPanel>
      )}
    </AnimatePresence>
  )
}
